import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MaskLine, Wordmark } from "../components/Motion";
import { useAuth } from "../context/AuthContext";

function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function SignUp() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await register(form); nav("/account"); }
    catch (e) { setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-20 sm:py-28" data-testid="signup-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-cs-yellow mb-4">Get 15% off</p>
      <h1 className="font-display font-extrabold text-5xl sm:text-6xl uppercase leading-[0.85]">
        <MaskLine>Create</MaskLine><MaskLine delay={0.1}>Account</MaskLine>
      </h1>
      <p className="text-graytx mt-5 leading-relaxed">
        Make an account to unlock your <span className="text-cream">15% off code</span>, early access to drops, and pre-order tracking.
      </p>

      <form onSubmit={submit} className="mt-10 space-y-6" data-testid="signup-form">
        {[["name", "Name", "text"], ["email", "Email", "email"], ["password", "Password", "password"]].map(([k, label, type]) => (
          <div key={k}>
            <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-graytx">{label}</label>
            <input required type={type} value={form[k]} onChange={set(k)} data-testid={`signup-${k}`}
              minLength={k === "password" ? 6 : undefined}
              className="w-full bg-transparent border-b border-line focus:border-cream py-3 outline-none transition-colors duration-200" />
          </div>
        ))}
        {err && <p className="text-cs-red text-sm" data-testid="signup-error">{err}</p>}
        <button disabled={loading} data-testid="signup-btn"
          className="w-full bg-cream text-bg font-mono text-[12px] uppercase tracking-[0.2em] py-4 hover:bg-cs-yellow disabled:opacity-60 transition-colors duration-200">
          {loading ? "Creating…" : "Create Account & Get 15%"}
        </button>
      </form>

      <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-graytx">
        Already have one? <Link to="/login" data-testid="to-login" className="text-cream hover:text-cs-yellow transition-colors duration-200">Log in</Link>
      </p>
      <div className="mt-12"><Wordmark className="text-2xl" /></div>
    </div>
  );
}
